export default __webpack_public_path__ + "static/media/menu.0b34bbc7.svg";